<template>
    <div v-if="isLoading" class="flex flex-col justify-between items-center w-full h-full">
        <div class="w-full flex justify-center items-center">
            Please wait while we send a reset link to your email.
        </div>
        <div class="w-12 h-12 py-8">
            <LoadingSpinner />
        </div>
    </div>
    <div v-else class="flex flex-col w-full h-full">
        <div v-if="registrationResponseType" class=" w-full">
            <div v-if="registrationResponseType=='success'" class="flex flex-col justify-center items-center space-y-4 w-full">
                <div class="w-full whitespace-pre-wrap pretty text-center">We've sent a reset link to <span class="text-indigo-600">{{ emailVerificationAddress }}</span>.</div>
                <div class="w-full whitespace-pre-wrap pretty text-center">Please check your inbox and follow the password reset link to proceed.</div>
                <!-- <div class="w-full whitespace-pre-wrap pretty">If you don't receive an email, this address may not be linked to an Aerocle account. Please click <tracked-link :link="{ path: '/register', label: 'Register', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800 cursor-pointer">here</span></tracked-link> to register.</div> -->
            </div>
            <div v-else-if="registrationResponseType=='error'" class="flex flex-col justify-center items-center space-y-4 w-full">
                <div class="w-full whitespace-pre-wrap pretty text-center">There was an error sending a reset link to <span class="text-indigo-600">{{ emailVerificationAddress }}</span>.</div>
                <div class="w-full whitespace-pre-wrap pretty text-center">{{ registrationResponse }}</div>
                <!-- <div class="w-full whitespace-pre-wrap pretty text-center">This address may not be linked to an Aerocle account.</div> -->
                <div class="w-full whitespace-pre-wrap pretty text-center"><span @click="resetForm" class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800 cursor-pointer">Try again</span> using an email registered with Aerocle or click <tracked-link :link="{ path: '/register', label: 'Register', displayLabel: false, class: 'inline'}"><span class="text-indigo-600 underline underline-offset-2 font-semibold hover:text-indigo-800 cursor-pointer">here</span></tracked-link> to register.</div>
            </div>
        </div>
        <form v-else @submit.prevent="passwordReset" action="" class="h-full w-full flex flex-col justify-center items-center space-y-4">
            <div class="pb-3 w-full flex flex-col space-y-4">
                <div class="w-full flex justify-center text-center">
                    Please enter the email associated with your Aerocle account and we'll send you reset instructions.
                </div>
                <div class="w-full">
                    <input class="p-3 w-full border border-gray-400 rounded-md" required type="email" placeholder="name@example.com" v-model="emailVerificationAddress">
                </div>
            </div>
            <div class="w-full pt-6 border-t border-gray-300">
                <button 
                    type="submit"
                    :disabled="!validForm"
                    class="px-4 py-3 bg-dark-primary text-white font-semibold  leading-tight rounded-md transition duration-150 ease-in-out w-full"
                    :class="{ 'hover:bg-[#181B4E] hover:shadow-md focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg' : validForm, 'opacity-50' : !validForm}"
                >
                    Reset Password
                </button>
            </div>   
        </form>
    </div>
</template>

<script setup>
import { defineProps, ref, reactive, computed, onMounted } from 'vue';
import { sendPasswordResetLink } from '@/services/Auth';
import TrackedLink from '../nav-bar-link-components/TrackedLink.vue';
import LoadingSpinner from '../base-components/LoadingSpinner.vue';
import { handleRestAuthResponseError } from '@/composables/djRestAuth';


const props = defineProps(['email'])
const isLoading = ref(false)
const registrationResponse = ref(null)
const registrationResponseType = ref(null)

const emailVerificationAddress = ref(props.email && props.email != 'null' ? props.email : null)


const validForm = computed(() => {
    let isValid = false
    if(emailVerificationAddress.value) {
        isValid = true
    }
    return isValid
})

function resetForm() {
    emailVerificationAddress.value = null
    registrationResponseType.value = null
    registrationResponse.value = null
}


async function passwordReset() {
    // console.log('resendEmail')
    isLoading.value = true
    const payload = JSON.stringify({
        email: emailVerificationAddress.value
    })
    // console.log(payload)
    const response = await sendPasswordResetLink(payload)
    // console.log('response')
    // console.log(response)

    setTimeout(() => {
        isLoading.value = false
        if(response && response.status == 200) {
            registrationResponseType.value = 'success'
        } else {
            registrationResponseType.value = 'error'
            registrationResponse.value = handleRestAuthResponseError(response)
        }
    }, 500)
}
</script>